import React from "react";
import { BrowserRouter, HashRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import "./App.css";

import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import StaticCheckoutPage from "./pages/StaticCheckoutPage";
import AccountPage from "./pages/AccountPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import ProductPage from "./pages/ProductPage";
import ProtectedRoute from "./components/ProtectedRoute";

import AdminDashboard from "./pages/AdminDashboard";
import AdminMenuPage from "./pages/AdminMenuPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import AdminCustomersPage from "./pages/AdminCustomersPage";

import RiderDashboard from "./pages/RiderDashboard";
import RiderOrdersPage from "./pages/RiderOrdersPage";
import { staticSite } from "./config";

function App() {
  const Router = staticSite ? HashRouter : BrowserRouter;
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/shop" element={<MenuPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/checkout" element={staticSite ? <StaticCheckoutPage /> : <ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
          <Route path="/orders" element={<Navigate to={staticSite ? "/" : "/account"} replace />} />

          <Route path="/account" element={staticSite ? <Navigate to="/" replace /> : <AccountPage />} />
          <Route path="/login" element={<Navigate to={staticSite ? "/" : "/account"} replace />} />
          <Route path="/register" element={<Navigate to={staticSite ? "/" : "/account"} replace />} />

          <Route path="/admin/login" element={staticSite ? <Navigate to="/" replace /> : <AdminLoginPage />} />
          <Route path="/admin" element={staticSite ? <Navigate to="/" replace /> : <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/menu" element={staticSite ? <Navigate to="/" replace /> : <ProtectedRoute role="admin"><AdminMenuPage /></ProtectedRoute>} />
          <Route path="/admin/orders" element={staticSite ? <Navigate to="/" replace /> : <ProtectedRoute role="admin"><AdminOrdersPage /></ProtectedRoute>} />
          <Route path="/admin/customers" element={staticSite ? <Navigate to="/" replace /> : <ProtectedRoute role="admin"><AdminCustomersPage /></ProtectedRoute>} />

          <Route path="/rider" element={staticSite ? <Navigate to="/" replace /> : <ProtectedRoute role="rider"><RiderDashboard /></ProtectedRoute>} />
          <Route path="/rider/orders" element={staticSite ? <Navigate to="/" replace /> : <ProtectedRoute role="rider"><RiderOrdersPage /></ProtectedRoute>} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
